import { UseCase } from 'src/app/core/utils/usecase';
import { DeleteClaimEntity } from '../entities/delete-claim.entity';
import { Failure } from 'src/app/core/utils/failure';
import { Injectable } from '@angular/core';
import { ClaimMultiRepositoryBase } from '../repositories/claim-multi-base.repository';

@Injectable()
export class DeleteMultiClaimUseCase
  implements UseCase<DeleteClaimEntity, string | Failure>
{
  constructor(private claimRepository: ClaimMultiRepositoryBase) {}

  async execute(param: DeleteClaimEntity): Promise<string | Failure> {
    return await this.claimRepository.deleteClaim(param);
  }
}
